import React, { useEffect, useState } from "react";
import SplashScreen from "../SplashScreen";

export default function ShowData() {

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // =====================================================
  // API URL
  // =====================================================

  const API_URL =
    "http://localhost/brobizee-api/get_user.php";


  // =====================================================
  // USER ID
  // =====================================================

  const userId =
    localStorage.getItem("user_id");


  // =====================================================
  // FETCH USER
  // =====================================================

  useEffect(() => {

    const fetchUserData = async () => {

      try {

        setLoading(true);
        setError("");


        // -------------------------------------------------
        // CHECK USER ID
        // -------------------------------------------------

        if (!userId) {

          setError(
            "User ID not found in localStorage"
          );

          setLoading(false);

          return;
        }


        console.log(
          "Fetching user:",
          userId
        );


        // -------------------------------------------------
        // API CALL
        // -------------------------------------------------

        const response = await fetch(
          `${API_URL}?user_id=${encodeURIComponent(userId)}`
        );


        // -------------------------------------------------
        // HTTP CHECK
        // -------------------------------------------------

        const responseText =
          await response.text();


        console.log(
          "RAW GET USER RESPONSE:",
          responseText
        );


        if (!response.ok) {

          throw new Error(
            `HTTP ${response.status}: ${responseText}`
          );
        }


        // -------------------------------------------------
        // JSON
        // -------------------------------------------------

        let data;

        try {

          data =
            JSON.parse(responseText);

        } catch (jsonError) {

          console.error(
            "Invalid JSON:",
            responseText
          );

          throw new Error(
            "PHP API returned invalid JSON"
          );
        }


        console.log(
          "GET USER RESULT:",
          data
        );


        // -------------------------------------------------
        // SUCCESS
        // -------------------------------------------------

        if (data.success) {

          setUser(data.user);

        } else {

          setError(
            data.message ||
            "Unable to fetch user data"
          );
        }

      } catch (error) {

        console.error(
          "Fetch user error:",
          error
        );

        setError(
          error.message ||
          "Something went wrong while loading user data"
        );

      } finally {

        setLoading(false);

      }

    };


    fetchUserData();

  }, [userId]);


  // =====================================================
  // LOADING
  // =====================================================

  if (loading) {

    return (

      <div className="show-data-page">

        <div className="show-data-card">

          <h2>
            {/* Loading user data... */}
             <SplashScreen />
          </h2>

        </div>

      </div>

    );

  }


  // =====================================================
  // ERROR
  // =====================================================

  if (error) {

    return (

      <div className="show-data-page">

        <div className="show-data-card">

          <h2>
            Error
          </h2>

          <p>
            {error}
          </p>

          <button
            type="button"
            onClick={() =>
              window.location.reload()
            }
          >
            Retry
          </button>

        </div>

      </div>

    );

  }


  // =====================================================
  // NO USER
  // =====================================================

  if (!user) {

    return (

      <div className="show-data-page">

        <div className="show-data-card">

          <h2>
            No user data found
          </h2>

        </div>

      </div>

    );

  }


  // =====================================================
  // SHOW USER DATA
  // =====================================================

  return (

    <div className="show-data-page">

      <div className="show-data-card">

        {/* =================================================
            TITLE
        ================================================== */}

        <h1>
          User Details
        </h1>


        {/* =================================================
            PROFILE
        ================================================== */}

        <div className="profile-section">

          {user.profile_url ? (

            <img
              src={user.profile_url}
              alt={user.name || "Profile"}
              className="profile-image"
              onError={(e) => {

                e.currentTarget.style.display =
                  "none";

              }}
            />

          ) : (

            <div className="profile-placeholder">

              <span>
                {user.name
                  ? user.name
                      .charAt(0)
                      .toUpperCase()
                  : "U"}
              </span>

            </div>

          )}


          <h2>
            {user.name || "No Name"}
          </h2>

        </div>


        {/* =================================================
            NAME
        ================================================== */}

        <div className="data-row">

          <span>
            Name
          </span>

          <strong>
            {user.name || "-"}
          </strong>

        </div>


        {/* =================================================
            PROFILE IMAGE
        ================================================== */}

        <div className="data-row">

          <span>
            Profile
          </span>

          <strong>

            {user.profile_user
              ? user.profile_user
              : "-"}

          </strong>

        </div>


        {/* =================================================
            USER ID
        ================================================== */}

        <div className="data-row">

          <span>
            User ID
          </span>

          <strong>
            {user.id}
          </strong>

        </div>


        {/* =================================================
            DEVICE UUID
        ================================================== */}

        <div className="data-row">

          <span>
            Device UUID
          </span>

          <strong>
            {user.device_uuid || "-"}
          </strong>

        </div>


        {/* =================================================
            LANGUAGE
        ================================================== */}

        <div className="data-row">

          <span>
            Language
          </span>

          <strong>
            {user.language || "-"}
          </strong>

        </div>


        {/* =================================================
            STATE
        ================================================== */}

        <div className="data-row">

          <span>
            State
          </span>

          <strong>
            {user.state || "-"}
          </strong>

        </div>


        {/* =================================================
            CITY
        ================================================== */}

        <div className="data-row">

          <span>
            City
          </span>

          <strong>
            {user.city || "-"}
          </strong>

        </div>


        {/* =================================================
            MOBILE
        ================================================== */}

        <div className="data-row">

          <span>
            Mobile Number
          </span>

          <strong>
            {user.mobile_number || "-"}
          </strong>

        </div>


        {/* =================================================
            OTP
        ================================================== */}

        <div className="data-row">

          <span>
            OTP
          </span>

          <strong>
            {user.otp_num || "-"}
          </strong>

        </div>


        {/* =================================================
            PROFILE IMAGE URL
        ================================================== */}

        {user.profile_url && (

          <div className="profile-url">

            <span>
              Profile URL
            </span>

            <a
              href={user.profile_url}
              target="_blank"
              rel="noreferrer"
            >
              Open Profile Image
            </a>

          </div>

        )}

      </div>

    </div>

  );

}